var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c('notifications',{attrs:{"position":"bottom right","closeOnClick":""}}),_c('notifications',{attrs:{"type":"security","group":"security","position":"bottom center"}}),_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }